import React, { useCallback, useMemo, useState } from 'react';
import Control from '../../../components/Control/Control';
import OutsideClick from '../../../components/OutsideClick/OutsideClick';
import { Col, Grid, Row } from '../../../grid';
import { NavigationClose, NavigationOpen } from '../../../icons';
import { block } from '../../../utils';
import { ItemColumnName } from '../../constants';
import Logo from '../Logo/Logo';
import MobileNavigation from '../MobileNavigation/MobileNavigation';
import Navigation from '../Navigation/Navigation';
import { NavigationListItem } from '../NavigationListItem/NavigationListItem';
import './Header.css';
const b = block('header');
const ICON_SIZE = 36;
const MobileMenuButton = ({ isSidebarOpened, onSidebarOpenedChange, }) => {
    const iconProps = {
        icon: isSidebarOpened ? NavigationClose : NavigationOpen,
        iconSize: ICON_SIZE,
    };
    return (React.createElement(Control, Object.assign({ className: b('mobile-menu-button'), onClick: (e) => {
            e.stopPropagation();
            onSidebarOpenedChange(!isSidebarOpened);
        }, size: "l" }, iconProps)));
};
const iconSizeKey = 'iconSize';
export const Header = ({ data, logo }) => {
    const { leftItems, rightItems, iconSize = 20 } = data;
    const [isSidebarOpened, setIsSidebarOpened] = useState(false);
    const [activeItemId, setactiveItemId] = useState(undefined);
    const getNavigationItemWithIconSize = useCallback((item) => {
        if (!(iconSizeKey in item)) {
            return Object.assign(Object.assign({}, item), { iconSize });
        }
        return item;
    }, [iconSize]);
    const leftItemsWithIconSize = useMemo(() => leftItems.map(getNavigationItemWithIconSize), [getNavigationItemWithIconSize, leftItems]);
    const rightItemsWithIconSize = useMemo(() => rightItems === null || rightItems === void 0 ? void 0 : rightItems.map(getNavigationItemWithIconSize), [getNavigationItemWithIconSize, rightItems]);
    const onActiveItemChange = useCallback((id) => {
        setactiveItemId(id);
    }, []);
    const hidePopup = useCallback(() => {
        onActiveItemChange();
    }, [onActiveItemChange]);
    const onSidebarOpenedChange = useCallback((isOpen) => {
        setIsSidebarOpened(isOpen);
    }, []);
    const hideSidebar = useCallback(() => {
        setIsSidebarOpened(false);
    }, []);
    return (React.createElement(Grid, { className: b() },
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement("header", { className: b('wrapper') },
                    logo && (React.createElement("div", { className: b('left') },
                        React.createElement(Logo, Object.assign({}, logo, { className: b('logo') })))),
                    React.createElement("div", { className: b('navigation-container') },
                        React.createElement(Navigation, { className: b('navigation'), links: leftItemsWithIconSize, activeItemId: activeItemId, onActiveItemChange: onActiveItemChange })),
                    React.createElement("div", { className: b('right') },
                        React.createElement(MobileMenuButton, { isSidebarOpened: isSidebarOpened, onSidebarOpenedChange: onSidebarOpenedChange }),
                        rightItemsWithIconSize && (React.createElement("ul", { className: b('buttons') }, rightItemsWithIconSize.map((button, index) => (React.createElement(NavigationListItem, { key: index, className: b('buttons-item'), item: button, index: index, activeItemId: activeItemId, hidePopup: hidePopup, column: ItemColumnName.Right, onActiveItemChange: onActiveItemChange })))))),
                    React.createElement(OutsideClick, { onOutsideClick: () => onSidebarOpenedChange(false) },
                        React.createElement(MobileNavigation, { topItems: leftItems, bottomItems: rightItems, isOpened: isSidebarOpened, activeItemId: activeItemId, onActiveItemChange: onActiveItemChange, onClose: hideSidebar })))))));
};
export default Header;
